import { GlobalNavGroup as GlobalNavGroupSDS } from '@snapchat/snap-design-system-marketing';
import { type FC, useContext } from 'react';

import { GlobalComponentsContext } from '../../context/GlobalComponentsContext';
import type { GlobalNavAllType } from '../../generated/contentful-types';
import { GlobalNavHighlight } from '../GlobalNavHighlight/GlobalNavHighlight';
import { GlobalNavItem } from '../GlobalNavItem/GlobalNavItem';

export const GlobalNavGroup: FC<GlobalNavAllType> = ({
  title,
  groupKey,
  itemsCollection,
  highlight,
}) => {
  const { isUrlCurrent } = useContext(GlobalComponentsContext);

  // TODO: This wasn't done here before. Might screw things up because of how bad the highlights
  // look on mobile. Should ask design before going live with this.
  const mobileNavHighlight = <GlobalNavHighlight {...highlight} />;
  return (
    <GlobalNavGroupSDS
      navGroupKey={groupKey}
      title={title}
      mobileHighlight={mobileNavHighlight}
      isExpandable
      isActive={itemsCollection?.items.some(item => isUrlCurrent?.(item.url))}
    >
      {itemsCollection?.items.map((itemProps, i) => (
        <GlobalNavItem key={`nav-item-${i}`} {...itemProps} />
      ))}
    </GlobalNavGroupSDS>
  );
};

GlobalNavGroup.displayName = 'GlobalNavGroup';
